import { render, staticRenderFns } from "./SearchClient.vue?vue&type=template&id=10aee441&scoped=true"
import script from "./SearchClient.vue?vue&type=script&lang=js"
export * from "./SearchClient.vue?vue&type=script&lang=js"
import style0 from "./SearchClient.vue?vue&type=style&index=0&id=10aee441&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aee441",
  null
  
)

export default component.exports